<script lang="ts">
  import { type HTMLAttributes } from 'vue'
  import { type AccessDeniedProps } from '../states/AccessDenied.vue'
  import { type PageMainProps } from './PageMain.vue'
  import { type PageHeaderProps } from './PageHeader.vue'
  import { type PageBodyProps } from './PageBody.vue'

  export interface PageProviderProps {
    class?: HTMLAttributes['class']
    accessProps?: AccessDeniedProps
    mainProps?: PageMainProps
    headerProps?: PageHeaderProps
    bodyProps?: PageBodyProps
  }
</script>

<script setup lang="ts">
  import { cn } from '@gat-ship/vue-components'

  const props = defineProps<PageProviderProps>()
</script>
<template>
  <div
    :class="
      cn(
        'relative mx-auto flex w-full max-w-[var(--content-max-width)] flex-1 flex-col self-stretch',
        props.class
      )
    "
  >
    <slot />
  </div>
</template>
